var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isReady)?_c('div',[_c('HeaderPage'),_c('router-view'),_c('FooterPage')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }